import {combineEpics, ofType} from "redux-observable";
import {loginEpic} from "../pages/login/epics.login";

export const rootEpic = combineEpics(
    loginEpic,
);
